<template>
  <div
    :class="[
      'title-widget text-body-1 text-uppercase font-weight-bold',
      noDecoration && 'title-widget-no-decoration',
      dark && 'title-widget-dark',
    ]"
  >
    <div
      :class="[
        'title-widget-text roboto-condensed px-4 py-1',
        dark ? 'white' : 'white--text secondary',
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noDecoration: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
};
</script>

<style>
.title-widget-text {
  width: max-content;
}

.title-widget:not(.title-widget-no-decoration)::after {
  content: "";
}

.title-widget::after {
  display: block;
  background: #dbdbdb;
  height: 1px;
}

.title-widget-dark::after {
  background: #484848;
}
</style>
